import { PortCallStatusEnum } from 'src/enums/stowage/portCallStatusEnum';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { RotationPortCall } from 'src/types/ViewModel/Stowage/Rotation/RotationPortCall';
import { StowagePlanChange } from 'src/types/ViewModel/Stowage/StowagePlanChange';
import { Violation } from 'src/types/ViewModel/Stowage/Violation/Violation';

export const getChangedPortCallStatus = (change: StowagePlanChange): PortCallStatusEnum | undefined => {
    const data: unknown = typeof change.data === 'string' ? JSON.parse(change.data) : change.data;
    return data && typeof data === 'object' && 'portCallStatus' in data && typeof data.portCallStatus === 'number' ? data.portCallStatus : undefined;
};

export const getPortCallDepartureLockReason = (call: RotationPortCall, rotation: RotationPortCall[], violations: Violation[]): string | null => {
    const index = rotation.findIndex((candidate) => candidate.portCallGuid === call.portCallGuid);
    if (index < 0) return 'Port call data is unavailable. Refresh the page before changing its status.';
    const affected = rotation
        .slice(0, index + 1)
        .filter((candidate) => candidate.portCallGuid === call.portCallGuid || candidate.portCallStatus === PortCallStatusEnum.Planned);
    const blocked = affected.find((candidate) =>
        violations.some(
            (violation) =>
                violation.type === StowageRuleConsequenceType.HardRule &&
                (violation.portCallGuid ?? violation.portCall?.portCallGuid) === candidate.portCallGuid
        )
    );
    return blocked
        ? `Cannot mark this call Departed: ${blocked.portDisplayName} (voyage ${blocked.voyageNumber}) has hard-rule violations. Resolve them first. Earlier Planned calls are also marked Departed by this action.`
        : null;
};
